// Placeholder content for the ScribbleReads landing page.

export const NAV_LINKS = [
  { label: "Discover", href: "#discover" },
  { label: "Features", href: "#features" },
  { label: "Community", href: "#community" },
  { label: "About", href: "#about" },
];

export const COMMUNITIES = [
  { name: "Fantasy Readers", members: "2.4k", tone: "coral", talking: "the map at the front of the book", books: ["coral", "yellow", "sage"] },
  { name: "Romance Readers", members: "3.1k", tone: "coral", talking: "slow burns that ruined us", books: ["coral", "sage"] },
  { name: "Mystery & Crime", members: "1.8k", tone: "blue", talking: "who actually did it", books: ["blue", "coral"] },
  { name: "Manga & Comics", members: "4.2k", tone: "yellow", talking: "this week's chapter drop", books: ["yellow", "blue", "coral"] },
  { name: "Classic Literature", members: "980", tone: "sage", talking: "why the ending still hurts", books: ["sage", "blue"] },
  { name: "Sci-Fi", members: "2.0k", tone: "blue", talking: "the physics, actually", books: ["blue", "sage"] },
  { name: "Poetry Corner", members: "1.1k", tone: "yellow", talking: "one line that undid me", books: ["yellow", "coral"] },
  { name: "Fiction Writers", members: "2.7k", tone: "coral", talking: "chapter one, take nine", books: ["coral", "yellow"] },
];

export const GENRES = [
  { name: "Fantasy", tone: "coral" }, { name: "Romance", tone: "coral" },
  { name: "Mystery", tone: "blue" }, { name: "Sci-Fi", tone: "blue" },
  { name: "Poetry", tone: "yellow" }, { name: "Comics", tone: "yellow" },
  { name: "Classics", tone: "sage" }, { name: "Short Stories", tone: "sage" },
  { name: "Fan Fiction", tone: "coral" }, { name: "Thriller", tone: "blue" },
];

export const FEATURES = [
  { key: "discover", title: "Discover", body: "Find your next favorite story with recommendations that actually understand your taste.", tone: "coral", size: "lg" },
  { key: "track", title: "Track", body: "Keep your whole reading journey in one calm, tidy place.", tone: "sage", size: "sm" },
  { key: "scribble", title: "Scribble", body: "Capture thoughts, quotes and mid-chapter reactions.", tone: "yellow", size: "sm" },
  { key: "collect", title: "Collect", body: "Build your personal reading universe, one shelf at a time.", tone: "blue", size: "wide" },
  { key: "share", title: "Share", body: "Let other readers discover what you're loving right now.", tone: "cream", size: "sm" },
  { key: "connect", title: "Connect", body: "Find people who get equally excited about fictional characters.", tone: "sage", size: "sm" },
];

export const JOURNEY = [
  { step: "01", title: "Discover", note: "\"Ooh, this one.\"", verb: "Find a story" },
  { step: "02", title: "Read", note: "\"Just one more chapter.\"", verb: "Fall into it" },
  { step: "03", title: "Scribble", note: "\"I have thoughts.\"", verb: "Note it down" },
  { step: "04", title: "Share", note: "\"You have to read this.\"", verb: "Pass it on" },
];

export const READERS = [
  { name: "mira.reads", handle: "Mira", book: "The Salt Grows Heavy", rating: 5, comment: "This book emotionally destroyed me. 10/10 would sob again.", likes: 214, tone: "coral" },
  { name: "quietpages", handle: "Jonah", book: "A Study in Drowning", rating: 4, comment: "Adding this to my TBR immediately. The vibes are immaculate.", likes: 98, tone: "sage" },
  { name: "chapterzero", handle: "Devi", book: "Piranesi", rating: 5, comment: "The ending??? We need to talk. Meeting in the comments.", likes: 340, tone: "yellow" },
  { name: "nightowlnotes", handle: "Sam", book: "The Bear and the Nightingale", rating: 5, comment: "Cozy, cold, and quietly devastating. My winter comfort read.", likes: 156, tone: "blue" },
];

export const REVIEW = {
  name: "olive.inink",
  handle: "Olive",
  book: "The House in the Cerulean Sea",
  rating: 5,
  quote: "A warm blanket of a book. I finished it and immediately wanted to start a found-family of my own.",
  scribble: "the good kind of cry",
};

export const SHELVES = {
  current: { title: "The Night Circus", author: "Erin Morgenstern", progress: 62, page: 248, total: 400 },
  discovery: [
    { title: "Babel", author: "R.F. Kuang", rating: 4.8, tone: "coral" },
    { title: "Circe", author: "Madeline Miller", rating: 4.9, tone: "yellow" },
    { title: "The Priory", author: "S. Shannon", rating: 4.6, tone: "sage" },
  ],
  activity: [
    { who: "Mira", did: "finished", what: "Piranesi" },
    { who: "Jonah", did: "shelved", what: "Babel" },
    { who: "Devi", did: "scribbled on", what: "Circe" },
  ],
};

export const DISCOVERY = [
  { cat: "Currently Trending", tone: "coral", books: [
    { title: "Fourth Wing", author: "R. Yarros", tone: "coral" },
    { title: "Yellowface", author: "R.F. Kuang", tone: "yellow" },
  ]},
  { cat: "Cozy Reads", tone: "sage", books: [
    { title: "Legends & Lattes", author: "T. Baldree", tone: "sage" },
    { title: "The Cerulean Sea", author: "TJ Klune", tone: "blue" },
  ]},
  { cat: "Can't Put It Down", tone: "yellow", books: [
    { title: "Project Hail Mary", author: "A. Weir", tone: "yellow" },
    { title: "The Silent Patient", author: "A. Michaelides", tone: "coral" },
  ]},
  { cat: "Hidden Gems", tone: "blue", books: [
    { title: "Piranesi", author: "S. Clarke", tone: "blue" },
    { title: "The Salt Grows Heavy", author: "C. White", tone: "sage" },
  ]},
  { cat: "On My TBR", tone: "coral", books: [
    { title: "The Bear & Nightingale", author: "K. Arden", tone: "coral" },
    { title: "A Study in Drowning", author: "A. Reid", tone: "yellow" },
  ]},
];

export const MARQUEE = [
  "Read it", "Scribble it", "Share it", "Cozy reads", "Late-night chapters",
  "Questionable fictional crushes", "TBR forever", "One more page",
];

// ---- Dummy data for the authenticated Home experience (prototype only) ----

export const CURRENT_USER = {
  name: "Sakshi",
  handle: "sakshi.reads",
  tagline: "Reader & Writer",
  initial: "S",
  tone: "coral",
  stats: { booksRead: 128, writing: 4, streak: 21 },
};

export const CONTINUE_READING = [
  { title: "The Night Circus", author: "Erin Morgenstern", progress: 62, page: 248, total: 400, tone: "coral" },
  { title: "Babel", author: "R.F. Kuang", progress: 34, page: 210, total: 620, tone: "yellow" },
  { title: "Piranesi", author: "Susanna Clarke", progress: 81, page: 178, total: 220, tone: "blue" },
];

export const RECENTLY_READ = [
  { title: "Circe", author: "Madeline Miller", rating: 5, tone: "yellow" },
  { title: "The Cerulean Sea", author: "TJ Klune", rating: 4.8, tone: "sage" },
  { title: "Legends & Lattes", author: "Travis Baldree", rating: 4.6, tone: "coral" },
  { title: "A Study in Drowning", author: "Ava Reid", rating: 4.5, tone: "blue" },
];

export const RECOMMENDED = [
  { title: "Fourth Wing", author: "Rebecca Yarros", rating: 4.7, tone: "coral", genre: "Fantasy", reason: "Because you loved Babel" },
  { title: "Yellowface", author: "R.F. Kuang", rating: 4.4, tone: "yellow", genre: "Fiction", reason: "Trending in your circles" },
  { title: "The Silent Patient", author: "Alex Michaelides", rating: 4.6, tone: "blue", genre: "Mystery", reason: "Because you liked a twisty plot" },
  { title: "Project Hail Mary", author: "Andy Weir", rating: 4.9, tone: "sage", genre: "Sci-Fi", reason: "Popular with Piranesi readers" },
];

// ---- Dummy data for the authenticated Explore experience (prototype only) ----

export const TRENDING_BOOKS = [
  { title: "Fourth Wing", author: "Rebecca Yarros", rating: 4.7, tone: "coral", stat: "+2.4k shelved this week" },
  { title: "Iron Flame", author: "Rebecca Yarros", rating: 4.6, tone: "yellow", stat: "Most discussed today" },
  { title: "Divine Rivals", author: "Rebecca Ross", rating: 4.5, tone: "sage", stat: "Rising fast" },
  { title: "House of Flame and Shadow", author: "Sarah J. Maas", rating: 4.8, tone: "blue", stat: "+1.9k shelved this week" },
];

export const EXPLORE_GENRES = [
  { key: "romance", label: "Romance", tone: "coral" },
  { key: "fantasy", label: "Fantasy", tone: "sage" },
  { key: "mystery", label: "Mystery", tone: "blue" },
  { key: "thriller", label: "Thriller", tone: "coral" },
  { key: "scifi", label: "Sci-Fi", tone: "yellow" },
  { key: "literary", label: "Literary Fiction", tone: "sage" },
  { key: "historical", label: "Historical", tone: "blue" },
  { key: "ya", label: "Young Adult", tone: "yellow" },
  { key: "nonfiction", label: "Non-Fiction", tone: "coral" },
];

export const CURATED_LISTS = [
  { title: "Books for a Rainy Sunday", curator: "ScribbleReads Editors", count: 12, tone: "blue" },
  { title: "Slow-Burn Romances", curator: "Romance Book Club", count: 18, tone: "coral" },
  { title: "Books That Will Ruin You Emotionally", curator: "ScribbleReads Editors", count: 9, tone: "sage" },
  { title: "Hidden Gems", curator: "Classic Literature", count: 15, tone: "yellow" },
];

export const PEOPLE_TO_FOLLOW = [
  { handle: "mira.reads", name: "Mira", tagline: "Fantasy & slow burns", tone: "coral", mutual: 3 },
  { handle: "quietpages", name: "Jonah", tagline: "Horror, mostly at night", tone: "sage", mutual: 1 },
  { handle: "chapterzero", name: "Devi", tagline: "Literary fiction lover", tone: "yellow", mutual: 5 },
  { handle: "nightowlnotes", name: "Sam", tagline: "Cozy fantasy & tea", tone: "blue", mutual: 2 },
];
